// extracted by mini-css-extract-plugin
export default {"Label":"o9FaeMvl"};